import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import { filter, flow } from 'lodash';
import withPopover from 'shared/hocs/withPopover';
import { withStyles } from '@material-ui/core';

import { SORT_FIELDS, SORT_DIRECTIONS, SORT_FIELDS_TYPES } from 'modules/queues/constants/appointmentsFilters';
import { getActiveSortField } from 'modules/queues/Schedule/selectors/appointmentsFilters';
import { setSortField, resetSort } from 'modules/queues/Schedule/actions/appointmentsFilters';

import SortBy from './SortBy';


const getIconTooltipMessage = (intl, activeSortField) => {
  if (activeSortField) {
    return intl.formatMessage(
      { id: 'Appointments.AppointmentsList.SortButton.Tooltip.Sorted' },
      {
        sortOption: intl.formatMessage(activeSortField.label),
        sortDirection: intl.formatMessage(SORT_DIRECTIONS[activeSortField.direction]).toLowerCase(),
      },
    );
  }

  return intl.formatMessage({ id: 'Appointments.AppointmentsList.SortButton.Tooltip', defaultMessage: '** Sort list' });
};

const getIconName = activeSortField => {
  if (activeSortField && activeSortField.direction === 'ASC') return 'arrow-up';
  if (activeSortField && activeSortField.direction === 'DESC') return 'arrow-down';
  return 'arrows-up-down';
};

export default compose(
  injectIntl,
  withPopover(),

  connect(
    (state) => ({ activeSortField: getActiveSortField(state) }),
    { setSortField, resetSort },
  ),

  withProps(({ intl, activeSortField, resetSort, closePopover }) => ({
    resetSort: flow(resetSort, closePopover),
    sortFields: filter(SORT_FIELDS, ({ key }) => key !== SORT_FIELDS_TYPES.CLOSED_TIME),
    iconTooltipMessage: getIconTooltipMessage(intl, activeSortField),
    iconName: getIconName(activeSortField),
  })),

  withStyles(({ topArrow }) => ({ topArrow })),
)(SortBy);
